import api from './api'
import axios from 'axios'

export const returnsService = {
  async getReturns(statuses = ['Initiated'], ebay = false) {
    return await api.get('/returns', { params: {
        status: statuses.join(','),
        ...(ebay && { ebay_returns: ebay })
    } })
  },

  async getReturn(id) {
    return await api.get(`/returns/${id}`)
  },

  async initiateReturn(saleId, data) {
    console.log('Return data', data)
    return await api.post(`/returns/initiate/${saleId}`, {
        ReturnReason: data.ReturnReason,
        TrackingNumber: data.TrackingNumber,
        TrackingService: data.TrackingService,
        InternalNotes: data.InternalNotes
    })
  },

  async updateReturn(id, data) {
    return await api.put(`/returns/${id}`, data)
  },

  async updateStatus(id, status) {
    return await api.put(`/returns/${id}/status`, { status })
  },

  async uploadFile(id, file) {
    const formData = new FormData()
    formData.append('file', file)
    return await api.post(`/returns/${id}/upload-file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  async issueRMA(id, data) {
    return await api.post(`/returns/${id}/issue-rma`, data)
  },

  async refundReturns(returns) {
    return await api.post('/returns/refund', {
      ids: returns
    })
  },

  async startShipment(id, data) {
    const response = await axios.post(`${api.defaults.baseURL}/returns/${id}/start-shipment`, data, {
      responseType: 'blob',
      headers: api.defaults.headers
    })
    return response.data
  },

  async closeSalesReturns(saleIds) {
    return await api.post('/returns/close-sales-returns', {
      saleIds
    })
  },

  async startMultipleShipment(returnIds) {
    const response = await axios.post(`${api.defaults.baseURL}/returns/start-shipment-multiple`, {
      ids: returnIds
    }, {
      responseType: 'blob',
      headers: api.defaults.headers
    })
    return response.data
  }
} 